<template>
    <section>
        <div class="row">
            <div class="col">
                <table class="table text-center">
                    <thead>
                        <tr>
                          <th width="25%">대상 활동</th>
                          <th width="50%">활동 내용</th>
                          <th width="25%">날짜</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-if="alarms.length === 0">
                            <th colspan="100%">알림이 없습니다.</th>
                        </tr>
                        <tr v-else v-for="log in alarms" @click="updateAlarmRead(log)">
                            <td :title="log.id">
                              <span v-if="log.type === 'QNA_NEW_QUESTION' || log.type === 'QNA_NEW_ANSWER'">Question</span>
                              <span v-else>{{log.activityTitle}}</span>
                            </td>
                            <td>
                                {{log.memberName}} 님,
                                <span v-if="log.msg">
                                    {{log.msg}}
                                </span>
                                <span v-else>
                                    {{!!alarmMap[log.type] ? alarmMap[log.type]['msg'] : ''}}
                                </span>
                            </td>
                            <td>
                              {{ $moment(log.createdDate).format('YYYY-MM-DD') }}
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </section>

</template>

<script>
    // import moment from 'moment';

    /* eslint-disable */
    export default {
        name: 'AlarmList',
        data() {
            return {
                alarms: [],
                alarmMap: {},
                search: {
                    page: 0,
                    size: 100,
                },
            }
        },
        components: {
        },
        props: {
            msgOnly: Boolean,
            memberId: Number,
        },
        methods: {
            getList() {
                let me = this;
                let u = new URLSearchParams(this.search).toString();

                let url = process.env.VUE_APP_MEMBER_API_URL + `/alarm/${this.memberId}?${u}`;
                this.axios.get(url)
                    .then(function (res) {
                        if(me.$props.msgOnly) {
                            // 봉사시간 알림: QNA 알림은 제외, msg가 있는 것만
                            me.alarms = res.data.filter(d => d.msg && d.type !== 'QNA_NEW_QUESTION' && d.type !== 'QNA_NEW_ANSWER');
                        } else {
                            // 활동 알림: QNA 알림 포함, msg가 없는 것 + QNA 알림
                            console.log('QNA 알림 데이터:', res.data.filter(d => d.type === 'QNA_NEW_QUESTION' || d.type === 'QNA_NEW_ANSWER'));
                            me.alarms = res.data.filter(d => !d.msg || d.type === 'QNA_NEW_QUESTION' || d.type === 'QNA_NEW_ANSWER');
                        }
                    }).catch(function (error) {
                    console.log(error);
                });
            },
            getAlarmTypeMap() {
                let me = this;
                let url = process.env.VUE_APP_MEMBER_API_URL + `/alarmMap`;
                this.axios.get(url)
                    .then(function (res) {
                        me.alarmMap = res.data;
                        // QNA 알림 url을 QnaShow로 강제 지정 (라우터 네임)
                        if(me.alarmMap['QNA_NEW_QUESTION']) me.alarmMap['QNA_NEW_QUESTION']['url'] = 'qnaShow';
                        if(me.alarmMap['QNA_NEW_ANSWER']) me.alarmMap['QNA_NEW_ANSWER']['url'] = 'qnaShow';
                    }).catch(function (error) {
                    console.log(error);
                });
            },
            updateAlarmRead(log) {
                let me = this;
                console.log('클릭한 알림 데이터:', log);
                if(log.isRead) {

                } else {

                    this.axios.put(process.env.VUE_APP_MEMBER_API_URL + `/alarm/${log.id}`)

                        .then(function (res) {
                        }).catch(function (error) {
                        console.log(error);
                    });

                }
                // QNA 알림이면 QnaShow로, id는 질문id 사용
                if(log.type === 'QNA_NEW_QUESTION' || log.type === 'QNA_NEW_ANSWER') {
                    // msg에서 질문 제목 추출
                    let titleMatch = log.msg.match(/: (.+)$/);
                    if (titleMatch) {
                        let title = titleMatch[1];
                        // QNA 목록 API를 호출해서 해당 제목의 질문 ID를 찾음
                        this.axios.get(`${process.env.VUE_APP_QNA_API_URL}/list`)
                          .then(res => {
                            if (res.data) {
                              // 제목이 일치하는 질문 찾기
                              const qna = res.data.find(q => q.title === title);
                              if (qna) {
                                this.$router.push({ name: 'qnaShow', params: { id: qna.id }});
                              }
                            }
                          });
                    }
                } else {
                    this.$router.push({ name: me.alarmMap[log.type]['url'], params: { id: log.activityId }});
                }
            },
            updateAlarmReadAll(log) {
                let me = this;
                if(log.isRead) {

                } else {

                    this.axios.put(process.env.VUE_APP_MEMBER_API_URL + `/alarm/readall/${this.memberId}`)
                        .then(function (res) {
                            // QNA 알림이면 QnaShow로, id는 activityId(=질문id)
                            if(log.type === 'QNA_NEW_QUESTION' || log.type === 'QNA_NEW_ANSWER') {
                                me.$router.push({ name: 'qnaShow', params: { id: log.activityId }})
                                .catch(err => console.error('라우팅 에러:', err));
                            } else {
                                me.$router.push({ name: me.alarmMap[log.type]['url'], params: { id: log.activityId }})
                                .catch(err => console.error('라우팅 에러:', err));
                            }
                        })
                        .catch(function (error) {
                            console.log('알림 읽음 처리 에러:', error);
                        });
                }
            },

        },
        mounted() {
            this.getList();
            this.getAlarmTypeMap();
        },
        created() {
        },

        watch: {}
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
